module.exports = __webpack_public_path__ + "static/media/green6.3f9f4fce.jpg";